import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

interface IFirstAidMeasurements {
  firstAidMeasures?: string;
  symptomsOrEffects?: string;
  recommendations?: string;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
  })
);

const FirstAidMeasurements: React.FC<IFirstAidMeasurements> = ({
  firstAidMeasures,
  symptomsOrEffects,
  recommendations,
  expanded,
  handleChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange(`panel2`)}
      key={'panel2'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel2bh-content`}
        id={`panel2bh-header`}
      >
        <Typography className={classes.heading}>{t('chemicals.first.aid.measures')}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.list}>
        {firstAidMeasures && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.first.aid.measures')}</b> ${firstAidMeasures}` }} />
        )}
        {symptomsOrEffects && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.symptoms_or_effects')}</b> ${symptomsOrEffects}` }} />
        )}
        {recommendations && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.recommendations')}</b> ${recommendations}` }} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default FirstAidMeasurements;
